import { postAPI } from "../../../../api/apis";
import { REACT_APP_CONTRACT } from "../../../../utils/common"

export async function getMyContracts(data: any) {
    const Details = postAPI( REACT_APP_CONTRACT + `/freelancer-contracts`,data)
    return Details
}

